import { inject } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { FormConfig } from '../edit-create-form.interfaces';
import { STUDY_PLAN_STATUS_SELECT_CONFIG, LEARNER_SELECT_CONFIG } from '@shared/components/generic-select/generic-select.configs';
import { SKILLS_MULTISELECT_CONFIG } from '@shared/components/generic-multiselect/generic-multiselect.configs';
import { LearnerApiService } from '@shared/services';
import { StudyPlanStatus } from '@shared/enums/study-plan.enum';

// Custom validator: endDate is required when status is CANCELLED or COMPLETED
function endDateRequiredForStatus(control: AbstractControl): ValidationErrors | null {
    const status = control.get('status')?.value;
    const endDate = control.get('endDate')?.value;

    if ((status === StudyPlanStatus.CANCELLED || status === StudyPlanStatus.COMPLETED) && !endDate) {
        return { endDateRequired: true };
    }

    return null;
}

export const studyPlanFormConfig = (): FormConfig => {
    const learnerApiService = inject(LearnerApiService);

    return {
        formValidators: [endDateRequiredForStatus],
        fields: [
            {
                key: 'id', label: 'ID', type: 'text', width: 'full', hidden: true
            },
            {
                key: 'learnerId', label: 'Học viên', required: true, width: 'full',
                type: 'select', config: { ...LEARNER_SELECT_CONFIG, service: learnerApiService },
                placeholder: 'Chọn học viên',
                disabled: (editMode: boolean) => editMode // Can't change learner in edit mode
            },
            {
                key: 'status', label: 'Trạng thái', required: true, width: 'half',
                type: 'select', config: { ...STUDY_PLAN_STATUS_SELECT_CONFIG },
                placeholder: 'Chọn trạng thái'
            },
            {
                key: 'skills', label: 'Kỹ năng', required: true, width: 'half',
                type: 'multiselect', config: { ...SKILLS_MULTISELECT_CONFIG },
                placeholder: 'Chọn kỹ năng',
                showDividerAfter: true
            },
            {
                key: 'startDate', label: 'Ngày bắt đầu', width: 'half',
                type: 'datepicker', placeholder: 'Chọn ngày bắt đầu'
            },
            {
                key: 'endDate', label: 'Ngày kết thúc', width: 'half',
                type: 'datepicker', placeholder: 'Chọn ngày kết thúc',
                showDividerAfter: true
            },
            {
                key: 'material', label: 'Tài liệu', width: 'full', rows: 2,
                type: 'textarea', placeholder: 'Nhập tài liệu học tập'
            },
            {
                key: 'spec', label: 'Mô tả chi tiết', width: 'full', rows: 4,
                type: 'textarea', placeholder: 'Nhập mô tả chi tiết'
            }
        ]
    };
};

